import qs from 'qs'

export const UTILS__ROUTER__add_query = (key, value, obj) => {
    const searchParams = qs.parse(obj.location.search, { ignoreQueryPrefix: true })
    obj.history.push({
        pathname: obj.location.pathname,
        search: qs.stringify({ ...searchParams, [key]: value }),
    })
}

export const UTILS__ROUTER__remove_query = (key, obj) => {
    const searchParams = qs.parse(obj.location.search, { ignoreQueryPrefix: true })
    delete searchParams[key]
    obj.history.push({
        pathname: obj.location.pathname,
        search: qs.stringify(searchParams),
    })
}
